import { __awaiter } from "tslib";
import config from "./config";
import { defaults, defaultPassOptions, defaultResolver, } from "./types";
import resolve from "./resolve";
import { create as createStorageAdapter } from "./storage/IdentityStorageAdapter";
import { getPasses } from "./passes";
const CivicProfile = {
    get: (query, options = defaults) => __awaiter(void 0, void 0, void 0, function* () {
        // Resolve the query to a DID, and fetch DID & address from the DID document.
        const { document, address } = yield resolve.resolveRequestToDid(query, options);
        const did = document.id;
        const resolver = options.resolver ? options.resolver : defaultResolver;
        // Fetch data from the Civic identity-store backend (with IPFS fallback):
        const storageAdapter = createStorageAdapter(did, resolver, options.civicIdentityStoreEndpoint || config.civicIdentityStoreEndpoint);
        const result = yield storageAdapter.get();
        const getPassesFunc = (passOptions = defaultPassOptions) => {
            return getPasses(address, Object.assign(Object.assign({}, defaultPassOptions), passOptions));
        };
        return Object.assign({ did,
            address, getPasses: getPassesFunc }, result);
    }),
};
export default CivicProfile;
